import React from 'react';
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import axios from 'axios';
import {Container, Row, Col, Form, Alert} from 'react-bootify';
import sprintf from 'yow/sprintf';


require('./testbench.css');

var config = require('../config.js');


export default class extends React.Component {

	constructor(props) {
		
		super(props);
	
        this.handleKeyPress = this.handleKeyPress.bind(this);
        
        this.state = {focus:'stockticker', inputs:{}, showAlert:false, ready:false, config:{}};
		
	};
	
    generate() {
     	var url = 'http://' + config.IP + '/mysql';

        // Nu och då
        var now = new Date();
        var then = new Date();
        

        // Håll koll på ett år tillbaks, vi visar bara ett år i grafen
        then.setFullYear(now.getFullYear() - 1);

        // Skapa läsbara texter från nu och då
        var nowYMD  = sprintf('%04d-%02d-%02d', now.getFullYear(), now.getMonth() + 1, now.getDate());
        var thenYMD = sprintf('%04d-%02d-%02d', then.getFullYear(), then.getMonth() + 1, then.getDate());

        // Skapa frågan
        var query = {};
        query.sql        = 'select date, open, high, low, close, volume from quotes where symbol = ? and date >= ?';
        query.values     = [this.state.inputs.ticker, thenYMD];

        var data = [];
        var volume = [];

        // Hämta data från Munch via ett '/mysql' anrop...
        axios.get(url, {params: query}).then(response => {
            var stocks = response.data;

            // Lägg till i vektorn 'data' på det format som Highcharts vill ha det
            stocks.forEach((stock, index) => {
                var date = new Date(stock.date);
                data.push([Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()), stock.open, stock.high, stock.low, stock.close, stock.volume]);
                volume.push([Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()), stock.volume]);                
            });

            // Skapa en Highcharts 'config'...
            var config = {
	            
				title: {
				text: this.props.symbol
				},
				
				subtitle: {
				  text: sprintf('%s - %s', thenYMD, nowYMD)
				},
				
				chart: {
					height: (9 / 16 * 100) + '%',
					panning: false,			    
				},
				
				rangeSelector: {
					enabled: false
				},
				
				navigator: {
					enabled: false
				},
				
				tooltip: {
					enabled: true
				},
				
				scrollbar: {
					enabled: false
				},

				xAxis: {
				  type: 'datetime',
				  			  
				  dateTimeLabelFormats: {
				        second: '%Y-%m-%d<br/>%H:%M:%S',
				        minute: '%Y-%m-%d<br/>%H:%M',
				        hour: '%Y-%m-%d<br/>%H:%M',
				        day: '%Y<br/>%m-%d',
				        week: '%Y<br/>%m-%d',
				        month: '%Y-%m',
				        year: '%Y'
				  }
				},

				yAxis: [{
				
				    labels: {
				        align: 'right',
				        x: -3
				    },
				    height: '75%',
				    lineWidth: 2,
				    resize: {
				        enabled: true
				    }
				}, {
				    labels: {
				        align: 'right',
				        x: -3
				    },
				    top: '65%',
				    height: '25%',
				    offset: 0,
				    lineWidth: 2
				}],

				plotOptions: {
				
				    series: {
						allowPointSelect: true,
				        dashStyle: 'solid',
						enableMouseTracking: true,
				        marker: {
				            enabled: false,
				            states: {
				                select: {
				                    enabled: false
				                },
				                hover: {
				                    enabled: false,
				                    halo: {
										size: 0
									}
				                },
				                normal: {
				                    animation: false
				                }
				                
				            }
				        }
				        
				    },
				
					ohlc: {
					    color: 'red',
					    upColor: 'green',
					    lineWidth: 1
				    }
				},

				series: [
				  	{
				        name: this.state.inputs.stockname,
				        id: 'STOCK',
				        type: 'ohlc',
				        data: data,
					},
					{
				        name: 'Volym',
				        type: 'column',
				        data: volume,
				        yAxis: 1,
					},
					{
						name: 'Velocity',
						type: 'column',
						data: data,
					}
				]

            };
            
            //config.xAxis.min = Date.UTC(oneYearAgo.getFullYear(), oneYearAgo.getMonth(), oneYearAgo.getDate());
            console.log("Hämtat grafdata", config);
            this.setState({ready:true, config:config});

        })
        .catch(error => {
            console.error(error);
        })

    }	
	
    handleKeyPress(target) {
        if (target.key == "Enter") {
            var self = this;
            //var request = require("client-request");
            var ticker = target.currentTarget.value;
            var url = "http://" + config.IP + "/company/" + ticker; 

			self.setState({ready:false});
            
            console.log("Hämtar:", ticker);

/*
            var options = {
                uri: "http://" + config.IP + "/company/" + ticker,
                method: "GET",
                timeout: 1000,
                json: true,
                headers: {
                    "content-type": "application/json"
                }
            };*/

            axios.get(url).then(response => {
                if (response.data != null) {
                    if (response.data[0] != "getYahooHistorical failed.") {		                    
						var inputs = self.state.inputs;

						console.log(response.data);
        
						inputs.stockname = response.data.price.shortName;
						inputs.ticker = ticker;							
						
						self.generate();
						
						self.setState({inputs:inputs, showAlert:false});
                    }
                    else {
                    	self.setState({showAlert:true});
                    }
                }
                else
					console.log("Fel: response.data = null");	                
            })
            .catch(error => {
				console.error(error);
	        })
        }
    }
	
	onCancel() {
        window.history.back();
    }
    
    dismissAlert() {
		this.setState({showAlert:!this.state.showAlert});
	}   
	
    stockGraph() {
	    
	    console.log("Ritar graf");
	    
        if (this.state.ready) {

            var style = {};
            style.border = '5px solid rgba(0, 0, 0, 0.1)';

            return (
                <div style = {style}>
	                <HighchartsReact highcharts={Highcharts} options={this.state.config}></HighchartsReact>
                </div>
            );
        }
        else
            return (<div></div>);	    
    }	 
	    
    render() {
	    	    
        return (
	        <div>
            <Container>
            
	            <Form padding={{top:3}} justifyContent="center">
	            	<Form.Row>
		                <Form.Input size='lg' autoFocus={this.state.focus=='stockticker'} value={this.state.inputs.stockticker} type="text" id="stockticker" placeholder="Ticker" onKeyPress={this.handleKeyPress.bind(this)}/>
					    <Alert show={this.state.showAlert} dismiss={this.dismissAlert.bind(this)} color='warning'>
					        Hittar inte ticker.
					    </Alert>                                                            
					</Form.Row>
				</Form>
            </Container>
	                
	            <Row>
	            	<Col alignContent="center">
						{this.stockGraph()}
					</Col>
	            </Row>							
	            </div>
	        
        );
    }
}
